var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHomepageChooseUs = function SvgHomepageChooseUs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 96,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#44A5CF",
    d: "M73.333 23.172V0H26.667v23.172H0V96h100V23.172zM40 13.242h20v9.93H40zm46.667 69.517H13.333V36.414h73.334z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#DC3456",
    d: "M66.668 52.967V66.21h-10v9.93H43.335v-9.93h-10V52.967h10v-9.93h13.333v9.93z"
  })));
};
export default SvgHomepageChooseUs;